import React, { ChangeEvent, useEffect, useState } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../utils/colors';
import { MoneyInput } from '../Inputs/MoneyInput';
import { Separator } from '../Separators/Separator';
import { t } from 'i18next';
import { ChoicesInput } from '../Inputs/ChoicesInput';
import { Service } from '../../models/Services';
import { SearchInput } from '../Inputs/SearchInput';

const FilterDiv = styled.div`
  width: 270px;
  background: white;
  margin-top: 10px;
  margin-left: 10px;
  box-shadow: 0 0 7px ${COLORS.gray_50};
  border: 0;
  border-radius: 10px;
  padding-block: 10px;
  padding-inline: 15px;
  display: flex;
  flex-direction: column;

  & > span {
    font-size: 0.9rem;
  }

  @media screen and (max-width: 700px) {
    width: 90%;
    box-shadow: 0 0 0 ${COLORS.gray_50};
    margin-top: 5px;
    margin-left: 0;
    border: 1px solid ${COLORS.gray_50};
  }
`;

const FilterButton = styled.button`
  background: ${COLORS.blue};
  color: ${COLORS.white};
  border: 0;
  border-radius: 5px;
  box-shadow: 0 0 7px ${COLORS.gray};

  &:hover {
    box-shadow: 0 0 0 ${COLORS.gray};
  }
`;

interface ServicesFilter {
  services: Service[];
  handleFilter: (
    maxPrice?: number,
    city?: string,
    searchString?: string,
  ) => void;
  handleResetFilters: () => void;
}

export const ServicesFilter: React.FC<ServicesFilter> = ({
  services,
  handleFilter,
  handleResetFilters,
}) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [servicesCities, setServicesCities] = useState<string[]>([]);
  const [maxMoney, setMaxMoney] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [selectedCity, setSelecetdCity] = useState<string>('');

  /* istanbul ignore next */
  const handleChangeMaxMoney = (event: ChangeEvent<HTMLInputElement>) =>
    setMaxMoney(event.target.value);

  /* istanbul ignore next */
  const handleChangeSearchValue = (event: ChangeEvent<HTMLInputElement>) =>
    setSearchValue(event.target.value);

  const resetFilters = () => {
    setMaxMoney('');
    setCity('');
    setSelecetdCity('');
    setSearchValue('');
    handleResetFilters();
  };

  useEffect(() => {
    const mappedAddresses = services.map(
      (service) => `${service.city}, ${service.country}`,
    );
    const filteredAddresses = mappedAddresses.filter(
      (value, index) => mappedAddresses.indexOf(value) === index,
    );
    setServicesCities(filteredAddresses);
  }, [services]);
  return (
    <FilterDiv>
      <span style={{ fontWeight: 500, fontSize: 16 }}>{t('filters')}</span>
      <Separator size={20} />
      <span>{t('services')}:</span>
      <Separator size={10} />
      <SearchInput
        id="services-filter-search-input"
        value={searchValue}
        onChange={handleChangeSearchValue}
      />
      <Separator size={20} />
      <span>{t('price_per_hour')} Max:</span>
      <Separator size={10} />
      <MoneyInput
        id="services-filter-max-money-input"
        value={maxMoney}
        onChange={handleChangeMaxMoney}
        placeholder="Max."
      />
      <Separator size={20} />
      <span>{t('city')}:</span>
      <Separator size={10} />
      <ChoicesInput
        id="services-filter-city-input"
        placeholder="Valencia, Spain"
        value={city}
        setValue={setCity}
        choices={servicesCities}
        handleSelectedChoice={setSelecetdCity}
        selectedValue={selectedCity}
      />
      <Separator size={30} />
      <FilterButton
        id="services-filter-filter-button"
        type="button"
        onClick={() =>
          handleFilter(
            Number.parseFloat(maxMoney),
            selectedCity || city,
            searchValue,
          )
        }>
        {t('filter')}
      </FilterButton>
      <Separator size={20} />
      <FilterButton
        id="services-filter-reset-button"
        type="button"
        onClick={resetFilters}
        style={{ background: COLORS.orange }}>
        {t('reset')}
      </FilterButton>
    </FilterDiv>
  );
};
